import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, HOME_FOR_ROLE } from '../context/AuthContext';

/**
 * Wraps a route to enforce authentication and (optionally) a role requirement.
 *
 * Usage:
 *   <ProtectedRoute role="admin"><AdminLayout>...</AdminLayout></ProtectedRoute>
 *   <ProtectedRoute role="premium"><Layout>...</Layout></ProtectedRoute>
 *
 * Behaviour:
 * - Not authenticated → redirect to /login?redirect=<current-path>
 * - Authenticated but wrong role → redirect to the user's own home
 */
function ProtectedRoute({ role, children }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  if (role && user.role !== role) {
    const home = HOME_FOR_ROLE[user.role] || '/';
    return <Navigate to={home} replace />;
  }

  return children;
}

export default ProtectedRoute;
